import { Indicator, Root } from '@radix-ui/react-progress';
import { useEffect, useState } from 'react';
import type { MergeExclusive } from 'type-fest';

import { classNames } from '../Utils/classNames';

type ProgressBarProps = MergeExclusive<
  { ['aria-label']: string },
  { ['aria-describedby']: string }
> & { progress: number; indicatorBgColor?: string };

export function ProgressBar({
  progress,
  indicatorBgColor,
  ...props
}: ProgressBarProps) {
  const [progressValue, setProgressValue] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => setProgressValue(progress), 1000);
    return () => clearTimeout(timer);
  }, [progress]);

  return (
    <Root
      value={progressValue}
      className="h-3 w-full min-w-[300px] overflow-hidden rounded-full bg-primary-2"
      {...props}
    >
      <Indicator
        style={{ width: `${progressValue}%` }}
        className={classNames(
          'h-full duration-300 ease-in-out',
          indicatorBgColor ? indicatorBgColor : 'bg-primary-6'
        )}
      />
    </Root>
  );
}
